import * as React from "react";
import {
  StyleSheet,
  View,
  Text,
  Image,
  Button,
  TouchableOpacity,
  ImageBackground,
  Animated,
  Easing,
  Platform,
  Dimensions,
} from "react-native";
import { PropsStackHome } from "../types";
import { themePattern } from "../constants/pattern";
import HomeDisplay from "../components/Cards/HomeDisplay";
import BtnSquareWhite from "../components/buttons/BtnSquareWhite";
import * as WebBrowser from "expo-web-browser";
import BtnRectangleHome from "../components/buttons/BtnRectangleHome";
import BtnSquare from "../components/buttons/BtnSquare";

const { width } = Dimensions.get("window");

const backgoundImage = require("./../assets/backgroud.png");
const basehome = require("./../assets/basehome.png");

const rota: any = "ModalNav";
const rotaHome: any = "DiscFront";
const rotaInstructions: any = "Instructions";
const rotaCredits: any = "Credits";
const rotaShared: any = "Shared";

const privacypolicy: any =
  "https://eic.ifsc.usp.br/app/privacypolicy/PoliticaPrivacidade_DiscoDeAminoacidos.pdf";

export default function DiscBackDesktop({ route, navigation }: PropsStackHome) {

  //Recurso dos patrocinadores - Desktop
  let ifsc = require("./../assets/ifsc.jpg");
  let cepi = require("./../assets/cepid.jpg");
  let cibfar = require("./../assets/cibfar.png");
  let eic = require("./../assets/eic.png");
  let fapesp = require("./../assets/fapesp.png");

  // Função Referencia
  let openHelp = () => {
    navigation.navigate(rotaInstructions); // open drawer
  };
  let openCredits = () => {
    navigation.navigate(rotaCredits); // open drawer
  };
  let openShared = () => {
    navigation.navigate(rotaShared); // open drawer
  };

  let onPress = () => {
    navigation.navigate(rota); // open drawer
  };
  let openPrivacypolicy = () => {
    WebBrowser.openBrowserAsync(privacypolicy);
  };
  let openHome = () => {
    navigation.navigate(rotaHome); // open drawer
  };

  function display() {
    if (width <= themePattern.breakpoint.mobile)
      return (
        <>
          <ImageBackground
            source={backgoundImage}
            resizeMode="cover"
            style={{
              flex: 1,
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <View style={styles.container}>
              <View style={styles.recuo}>  
              </View>

              <View style={styles.display}>
                
                <HomeDisplay />
              </View>

              <View style={styles.recuo}></View>
            </View>
          </ImageBackground>
        </>
      );
    else
      return (
        <>
          <ImageBackground
            source={backgoundImage}
            resizeMode="cover"
            style={{
              flex: 1,
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <View style={styles.container}>
              <View style={styles.recuo}>
                <View style={styles.titleContainer}>
                  <Text style={styles.title}>DISCO DE AMINOÁCIDOS</Text>
                </View>
              </View>
              <View style={styles.display}>
                <View style={styles.cols}>
                  <View style={styles.itemSide}>
                    <View style={stylesSide.patrocinadorLayout}>
                      <View style={stylesSide.patrocinadorContainer}>
                        <View style={stylesSide.container}>
                          <View style={stylesSide.item}>
                            <Image
                              source={ifsc}
                              style={stylesSide.logoImage}
                              resizeMode="contain"
                            />
                          </View>
                          <View style={stylesSide.item}>
                            <Image
                              source={eic}
                              style={stylesSide.logoImage}
                              resizeMode="contain"
                            />
                          </View>

                          <View style={stylesSide.item}>
                            <Image
                              source={cibfar}
                              style={stylesSide.logoImage}
                              resizeMode="contain"
                            />
                          </View>
                        </View>
                      </View>
                    </View>

                    <View style={stylesSide.botoesLayout}>
                      <View style={stylesNav.Opcoes}>
                        <View style={stylesNav.item}>
                          <BtnSquare
                            icon={"question"}
                            key={"ajuda"}
                            name={"SOBRE A MÍDIA"}
                            onPress={() => openHelp()}
                          />
                        </View>
                        <View style={stylesNav.item}>
                          <BtnSquare
                            icon={"group"}
                            key={"creditos"}
                            name={"CRÉDITOS"}
                            onPress={() => openCredits()}
                          />
                        </View>
                      </View>
                    </View>
                  </View>

                  <View style={styles.itemCenter}>
                    <View style={stylesNav.base}>
                      <Image
                        source={basehome}
                        style={stylesNav.imagem}
                        resizeMode="contain"
                      />

                      <BtnRectangleHome
                        icon={""}
                        key={"iniciar"}
                        name={"INICIAR"}
                        onPress={() => openHome()}
                      />
                    </View>
                  </View>

                  <View style={styles.itemSide}>
                    <View style={stylesSide.patrocinadorLayout}>
                      <View style={stylesSide.patrocinadorContainer}>
                        <View style={stylesSide.container}>
                          <View style={stylesSide.item}>
                            <Image
                              source={fapesp}
                              style={stylesSide.logoImage}
                              resizeMode="contain"
                            />
                          </View>
                          <View style={stylesSide.item}>
                            <Image
                              source={cepi}
                              style={stylesSide.logoImage}
                              resizeMode="contain"
                            />
                          </View>
                        </View>
                      </View>
                    </View>
                    <View style={stylesSide.botoesLayout}>
                      <View style={stylesNav.Opcoes}>
                        <View style={stylesNav.item}>
                          <BtnSquare
                            icon={"share-alt"}
                            key={"compartilhar"}
                            name={"COMPARTILHAR"}
                            onPress={() => openShared()}
                          />
                        </View>
                        <View style={stylesNav.item}>
                          <BtnSquare
                            icon={"ban"}
                            key={"PRIVACIDADE"}
                            name={"PRIVACIDADE"}
                            onPress={() => openPrivacypolicy()}
                          />
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </ImageBackground>
        </>
      );
  }

  return <View style={styles.main}>{display()}</View>;
}

function Styles() {
  //Mobile
  if (themePattern.breakpoint.mobile >= width)
    return StyleSheet.create({
      main: {
        flex: 1,
      },
      container: {
        flex: 1,
        margin: themePattern.desktop.retreat,
      },
      recuo: {
        flex: 1,
      },
      display: {
        flex: 10,
      },
      titleContainer: {},
      title: {},
      cols: {},
      itemSide: {},
      itemCenter: {},
    });
  //Tablet
  else
    return StyleSheet.create({
      main: {
        flex: 1,
      },
      container: {
        flex: 1,
        marginLeft:
          width > 1300
            ? themePattern.desktop.retreatDesketop
            : themePattern.desktop.retreat,
        marginRight:
          width > 1300
            ? themePattern.desktop.retreatDesketop
            : themePattern.desktop.retreat,
        marginTop: themePattern.desktop.retreat,
        marginBottom: themePattern.desktop.retreat,
        width: width > 1300 ? 1200 : "auto",
        flexDirection: "column",
      },
      recuo: {
        flex: 1,
        zIndex: 2,
        elevation: 2,
      },
      display: {
        zIndex: 0,
        elevation: 0,
        flex: 8,
      },
      titleContainer: {
        borderRadius: themePattern.desktop.retreat,
        backgroundColor: themePattern.desktop.white,
        width: "max-content",
        alignSelf: "center",
        padding: themePattern.desktop.retreat,
        paddingLeft:50,
        paddingRight: 50
      },
      title: {
        fontSize: themePattern.desktop.title1,
        fontWeight: "bold",

      },
      cols: {
        flex: 1,
        flexDirection: "row",
      },
      itemSide: {
        flex: 1,
        padding: themePattern.desktop.retreat,
        flexDirection: "column",
      },
      itemCenter: {
        flex: width > 900 ? 3 : width > 800 ? 2 : 1,
        padding: themePattern.desktop.retreat,
      },
      patrocios: {},
    });
}

const styles = Styles();

// Apenas Desktop
const stylesSide = StyleSheet.create({
  main: {
    flex: 1,
  },
  container: {
    justifyContent: "center",
    flexDirection: "column",
    flex: 1,
  },
  item: {
    flex: 1,
    padding: 5,
    paddingLeft: 15,
    paddingRight: 15,
  },
  logoImage: {
    width: "auto",
    height: "100%",
  },
  patrocinadorContainer: {
    backgroundColor: themePattern.desktop.white,
    height: 300,
    borderRadius: themePattern.desktop.retreat,
  },
  botoesLayout: {
    height: 100,
    flex: 1,
  },
  patrocinadorLayout: {
    flex: 7,
    justifyContent: "center"
  },
});

const stylesNav = StyleSheet.create({
  bar: {
    flex: 1,
  },

  Opcoes: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  item: {
    flex: 1,
    height: "100%",
    justifyContent: "flex-end",
    flexDirection: "column",
  },
  base: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },
  imagem: {
    width: "99%",
    height: "99%",
    position: "absolute",
    zIndex: 0,
  },
});
